import React from 'react';
import { useLanguage } from '@/components/ui/LanguageContext';
import { motion } from 'framer-motion';
import { Shield } from 'lucide-react';

export default function Privacy() {
  const { language } = useLanguage();

  return (
    <div className="min-h-screen bg-black text-white pb-20">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
        >
          <div className="flex items-center gap-3 mb-8">
            <div className="p-3 rounded-xl bg-indigo-500/20">
              <Shield className="w-6 h-6 text-indigo-400" />
            </div>
            <h1 className="text-3xl font-bold">
              {language === 'ja' ? 'プライバシーポリシー' : 'Privacy Policy'}
            </h1>
          </div>

          <div className="prose prose-invert prose-zinc max-w-none">
            <p className="text-zinc-400 mb-8">
              {language === 'ja' ? '最終更新日: 2024年1月1日' : 'Last updated: January 1, 2024'}
            </p>

            <section className="mb-8">
              <h2 className="text-xl font-semibold mb-4">
                {language === 'ja' ? '1. 収集する情報' : '1. Information We Collect'}
              </h2>
              <ul className="list-disc list-inside text-zinc-300 space-y-2">
                <li>{language === 'ja' ? 'Discordアカウント情報（ユーザー名、メールアドレス、アバター）' : 'Discord account information (username, email, avatar)'}</li>
                <li>{language === 'ja' ? '学習進捗データ' : 'Learning progress data'}</li>
                <li>{language === 'ja' ? '支払い情報（Stripeで安全に処理）' : 'Payment information (securely processed by Stripe)'}</li>
                <li>{language === 'ja' ? '利用ログ（アクセス日時、視聴履歴）' : 'Usage logs (access times, viewing history)'}</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold mb-4">
                {language === 'ja' ? '2. 情報の利用目的' : '2. How We Use Your Information'}
              </h2>
              <ul className="list-disc list-inside text-zinc-300 space-y-2">
                <li>{language === 'ja' ? 'サービスの提供・運営' : 'Providing and operating the Service'}</li>
                <li>{language === 'ja' ? '学習体験のパーソナライズ' : 'Personalizing your learning experience'}</li>
                <li>{language === 'ja' ? 'カスタマーサポート' : 'Customer support'}</li>
                <li>{language === 'ja' ? 'サービスの改善' : 'Improving our Service'}</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold mb-4">
                {language === 'ja' ? '3. 情報の共有' : '3. Information Sharing'}
              </h2>
              <p className="text-zinc-300 leading-relaxed">
                {language === 'ja'
                  ? '当社は、法令に基づく場合、またはお客様の同意がある場合を除き、個人情報を第三者と共有しません。決済処理にはStripeを利用しています。'
                  : 'We do not share your personal information with third parties except as required by law or with your consent. We use Stripe for payment processing.'}
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold mb-4">
                {language === 'ja' ? '4. データの保護' : '4. Data Security'}
              </h2>
              <p className="text-zinc-300 leading-relaxed">
                {language === 'ja'
                  ? '当社は、お客様のデータを保護するために適切なセキュリティ対策を講じています。ただし、インターネット上での情報伝送は完全に安全ではないことをご理解ください。'
                  : 'We implement appropriate security measures to protect your data. However, please understand that no method of internet transmission is completely secure.'}
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold mb-4">
                {language === 'ja' ? '5. お問い合わせ' : '5. Contact Us'}
              </h2>
              <p className="text-zinc-300 leading-relaxed">
                {language === 'ja'
                  ? 'プライバシーに関するご質問は、ヘルプページのお問い合わせフォームよりご連絡ください。'
                  : 'For privacy-related questions, please contact us through the form on our Help page.'}
              </p>
            </section>
          </div>
        </motion.div>
      </div>
    </div>
  );
}